export const START_USER_PROFILE_UPDATE = 'START_USER_PROFILE_UPDATE';
export const USER_PROFILE_UPDATE_SUCCESS = 'USER_PROFILE_UPDATE_SUCCESS';
export const USER_PROFILE_UPDATE_FAILURE = 'USER_PROFILE_UPDATE_FAILURE';

export const SHOW_PROFILE_MODAL = 'SHOW_PROFILE_MODAL';
export const HIDE_PROFILE_MODAL = 'HIDE_PROFILE_MODAL';

export const SHOW_NOTIFICATION_PREFERENCES_MODAL = 'SHOW_NOTIFICATION_PREFERENCES_MODAL';
export const HIDE_NOTIFICATION_PREFERENCES_MODAL = 'HIDE_NOTIFICATION_PREFERENCES_MODAL';
